import { AppEvent } from "@lib/titan2/dist/game/Constants";
import { AbstractGameController } from "@lib/titan2/dist/game/controller/AbstractGameController";
import { Logger } from "@lib/titan2/dist/util/log/Logger";
import { SlingoEvent } from "./event/SlingoEvent";
/**
 * TicketController.ts
 */
export class TicketController extends AbstractGameController {
    create() {
        super.create();
        Logger.addObjectRef(this, "TicketController");
    }
    createModel() {
        super.createModel();
        this.model = this.baseModel;
    }
    addEventListeners() {
        super.addEventListeners();
        this.registerGame(SlingoEvent.SPIN_RESULT, this.handleSpinResult);
        this.registerGame(SlingoEvent.REELS_START, this.handleReelsStart);
        this.registerGame(SlingoEvent.REELS_COMPLETE, this.handleReelsComplete);
        this.registerGame(SlingoEvent.DAB_REQUEST, this.handleDabRequest);
        this.registerGame(SlingoEvent.CHOOSE_CELL_RESULT, this.handleChooseCellResult);
        this.registerGame(SlingoEvent.SLINGO_COMPLETE, this.handleSlingoComplete);
    }
    handleSpinResult() {
        this.updateDarkenedReels();
    }
    updateDarkenedReels() {
        let reelDisplayData = this.model.getReelDisplayData();
        let result = this.model.getSpinResult();
        let reelSequence = result.getReelSequence();
        let symbols = reelSequence.getSymbols();
        let jokerIndexes = reelSequence.getJokerIndexes();
        let superJokerIndexes = reelSequence.getSuperJokerIndexes();
        let darkenedReels = [];
        for (let reelIndex = 0; reelIndex < symbols.length; reelIndex++) {
            let symbol = symbols[reelIndex];
            if (symbol.isJoker()) {
                if (jokerIndexes.indexOf(reelIndex) < 0) {
                    darkenedReels.push(reelIndex);
                }
            }
            else if (symbol.isSuperJoker()) {
                if (superJokerIndexes.indexOf(reelIndex) < 0) {
                    darkenedReels.push(reelIndex);
                }
            }
        }
        reelDisplayData.setDarkenedReels(darkenedReels);
    }
    handleDabRequest() {
        this.dispatchCore(AppEvent.BUSY);
        let dabData = this.model.getDabData();
        let selectedCell = dabData.getSelectedCell();
        if (dabData.isNumberCell(selectedCell)) {
            this.handleNumberCell();
        }
        else {
            if (dabData.isSuperJokerCell(selectedCell)) {
                let spinResult = this.model.getSpinResult();
                let sequence = spinResult.getReelSequence();
                let superJokerIndexes = sequence.getSuperJokerIndexes();
                let superJokerIndex = superJokerIndexes[0];
                dabData.setSuperJokerIndex(superJokerIndex);
                this.model.dispatchKPI("SLINGO_STATE", "SUPER_WILD_SELECTION_ENDED", selectedCell.getNumber().toString());
            }
            else {
                this.model.dispatchKPI("SLINGO_STATE", "WILD_SELECTION_ENDED", selectedCell.getNumber().toString());
            }
            this.dispatchGame(SlingoEvent.CHOOSE_CELL_REQUEST);
        }
    }
    handleNumberCell() {
        this.handleDabSuccess();
    }
    handleChooseCellResult() {
        this.handleDabSuccess();
    }
    handleDabSuccess() {
        let ticket = this.model.getTicket();
        let dabData = this.model.getDabData();
        let selectedCell = dabData.getSelectedCell();
        ticket.dab(selectedCell.getNumber());
        dabData.dabSuccess();
        this.dispatchGame(SlingoEvent.DAB_SUCCESS);
        this.updateCells();
    }
    updateCells() {
        this.resetCells();
        this.updateStandardCells();
        this.updateJokerCells();
        this.updateSuperJokerCells();
        this.updateDabState();
    }
    handleReelsStart() {
        this.updateAutoHighlightCells();
    }
    handleReelsComplete() {
        this.resetTicketDabs();
        this.updateCells();
    }
    resetTicketDabs() {
        let ticketDab = this.model.getDabData();
        ticketDab.resetDabs();
    }
    resetCells() {
        let dabData = this.model.getDabData();
        dabData.resetCells();
    }
    updateStandardCells() {
        let dabData = this.model.getDabData();
        let spinResult = this.model.getSpinResult();
        let autoDabbedCells = [];
        let matchedNumbers = spinResult.getMatchedNumbers();
        if (matchedNumbers.length > 0) {
            let ticket = this.model.getTicket();
            for (let i = 0; i < matchedNumbers.length; i++) {
                let cellNumber = matchedNumbers[i];
                let cell = ticket.getCell(cellNumber);
                if (!cell.isCalled() && !cell.isDabbed()) {
                    ticket.call(cellNumber);
                    autoDabbedCells.push(cell);
                }
            }
        }
        dabData.setAutoDabCells(autoDabbedCells);
    }
    updateJokerCells() {
        let dabData = this.model.getDabData();
        let spinResult = this.model.getSpinResult();
        let jokerCells = [];
        let cellNumbers = spinResult.getJokerCells();
        if (cellNumbers.length > 0) {
            let ticket = this.model.getTicket();
            for (let i = 0; i < cellNumbers.length; i++) {
                jokerCells.push(ticket.getCell(cellNumbers[i]));
            }
        }
        dabData.setJokerCells(jokerCells);
    }
    updateSuperJokerCells() {
        let dabData = this.model.getDabData();
        let spinResult = this.model.getSpinResult();
        let superJokerCells = [];
        let cellNumbers = spinResult.getSuperJokerCells();
        if (cellNumbers.length > 0) {
            let ticket = this.model.getTicket();
            for (let i = 0; i < cellNumbers.length; i++) {
                superJokerCells.push(ticket.getCell(cellNumbers[i]));
            }
        }
        dabData.setSuperJokerCells(superJokerCells);
    }
    handleSlingoComplete() {
        this.model.setSlingoInProgress(false);
        if (this.model.isAutoDabComplete()) {
            this.model.setAutoDabComplete(false);
            let dabData = this.model.getDabData();
            dabData.hasCellToDab() ? this.handleDabActive() : this.handleDabComplete();
        }
        else {
            this.updateDabState();
        }
    }
    updateAutoHighlightCells() {
        const dabData = this.model.getDabData();
        const spinResult = this.model.getSpinResult();
        const autoHighlightCells = [];
        const matchedNumbers = spinResult.getMatchedNumbers();
        const ticket = this.model.getTicket();
        if (matchedNumbers.length > 0) {
            for (let i = 0; i < matchedNumbers.length; i++) {
                let cellNumber = matchedNumbers[i];
                let cell = ticket.getCell(cellNumber);
                if (!cell.isDabbed()) {
                    autoHighlightCells.push(cell);
                }
            }
        }
        dabData.setAutoHighlightCells(autoHighlightCells);
    }
    updateDabState() {
        //Logger.debug("TicketController.updateDabState")
        const dabData = this.model.getDabData();
        const autoDabCells = dabData.getAutoDabCells();
        let autoDabIndex = dabData.getAutoDabIndex();
        if (autoDabIndex < autoDabCells.length) {
            this.handleAutoDabSuccess();
        }
        else {
            this.handleAutoDabComplete();
        }
    }
    handleAutoDabSuccess() {
        //Logger.debug("TicketController.handleAutoDabSuccess");
        const ticket = this.model.getTicket();
        const dabData = this.model.getDabData();
        const autoDabCells = dabData.getAutoDabCells();
        let autoDabIndex = dabData.getAutoDabIndex();
        const selectedCell = autoDabCells[autoDabIndex];
        ticket.dab(selectedCell.getNumber());
        dabData.autoDabSuccess();
        dabData.setSelectedCell(selectedCell);
        this.dispatchGame(SlingoEvent.DAB_SUCCESS);
        let matchedSlingo = this.matchPatterns(true);
        if (matchedSlingo) {
            this.model.setAutoDabComplete(false);
            //Logger.debug("TicketController.handleAutoDabSuccess.matchedSlingo");            
        }
        else {
            this.callAfter(this.model.getAutoDabInterval(), this.updateDabState);
            //Logger.debug("TicketController.handleAutoDabSuccess.updateDabState:after " + String(this.model.getAutoDabInterval()));
        }
    }
    handleAutoDabComplete() {
        //Logger.debug("TicketController.handleAutoDabComplete")
        let matchedSlingos = this.matchPatterns(true);
        if (matchedSlingos) {
            this.model.setAutoDabComplete(true);
        }
        else {
            let dabData = this.model.getDabData();
            dabData.hasCellToDab() ? this.handleDabActive() : this.handleDabComplete();
        }
    }
    matchPatterns(matchSlingos) {
        let dabData = this.model.getDabData();
        let progress = this.model.getGameProgress();
        let payoutConfig = this.model.getPayoutConfig();
        let patterns = payoutConfig.getPatterns();
        let matchedPatterns = this.model.getMatchedPatterns();
        let winningPatterns = [];
        for (let i = 0; i < patterns.length; i++) {
            let pattern = patterns[i];
            let key = pattern.getKey();
            if (!matchedPatterns.containsKey(key)) {
                if (this.matchPattern(pattern)) {
                    matchedPatterns.setValue(key, pattern);
                    winningPatterns.push(pattern);
                }
            }
        }
        // PH Defensive sanity check for matched patterns
        let numberOfMatchedPatterns = Math.min(matchedPatterns.size(), progress.getMatchedPatterns());
        this.model.setCurrentMatchedPatterns(numberOfMatchedPatterns);
        let hasMatched = false;
        if (matchSlingos) {
            let numberOfSlingos = winningPatterns.length;
            hasMatched = numberOfSlingos > 0;
            if (hasMatched) {
                this.model.setSlingoPatterns(winningPatterns);
                dabData.slingoSuccess(numberOfSlingos);
                this.model.setSlingoInProgress(true);
                this.dispatchGame(SlingoEvent.SLINGO);
            }
        }
        return hasMatched;
    }
    matchPattern(patternSet) {
        let rows = patternSet.getRows();
        let columns = patternSet.getColumns();
        let ticket = this.model.getTicket();
        let matched = true;
        for (let row = 0; row < rows; row++) {
            for (let column = 0; column < columns; column++) {
                let ticketCell = ticket.getCellAt(row, column);
                let patternCell = patternSet.getCell(row, column);
                if (patternCell.isActive() && !ticketCell.isDabbed()) {
                    matched = false;
                    break;
                }
            }
        }
        return matched;
    }
    handleDabActive() {
        //Logger.debug("TicketController.handleDabActive");
        this.dispatchGame(SlingoEvent.DAB_ACTIVE);
    }
    handleDabComplete() {
        //Logger.debug("TicketController.handleDabComplete");
        this.dispatchGame(SlingoEvent.DAB_COMPLETE);
    }
    updateRecovery() {
        let result = this.model.getSpinResult();
        if (result) {
            this.updateDarkenedReelsRecovery();
            this.updateTicketRecovery();
            this.resetCells();
            this.updateStandardCells();
            this.updateJokerCells();
            this.updateSuperJokerCells();
            this.matchPatterns(false);
        }
    }
    updateDarkenedReelsRecovery() {
        let reelDisplayData = this.model.getReelDisplayData();
        let result = this.model.getSpinResult();
        let reelSequence = result.getReelSequence();
        let symbols = reelSequence.getSymbols();
        let recovery = this.model.getRecovery();
        let matchedNumbers = recovery ? recovery.getMatchedNumbers() : this.model.getGameProgress().getMatchedNumbers(); //
        let jokerIndexes = reelSequence.getJokerAndSuperJokerIndexes();
        let darkenedReels = [];
        for (let reelIndex = 0; reelIndex < symbols.length; reelIndex++) {
            let symbol = symbols[reelIndex];
            if (symbol.isNumber()) {
                let cellNumber = parseInt(symbol.getId());
                if (matchedNumbers?.indexOf(cellNumber) >= 0 && jokerIndexes.indexOf(reelIndex) < 0) {
                    darkenedReels.push(reelIndex);
                }
            }
            else if (symbol.isJoker() || symbol.isSuperJoker()) {
                if (jokerIndexes?.indexOf(reelIndex) < 0) {
                    darkenedReels.push(reelIndex);
                }
            }
        }
        reelDisplayData.setDarkenedReels(darkenedReels);
    }
    updateTicketRecovery() {
        let ticket = this.model.getTicket();
        let recovery = this.model.getRecovery();
        let matchedNumbers = recovery ? recovery.getMatchedNumbers() : this.model.getGameProgress().getMatchedNumbers(); //
        for (let i = 0; i < matchedNumbers.length; i++) {
            let matchedNumber = matchedNumbers[i];
            ticket.dab(matchedNumber);
        }
    }
    updateDabRecovery() {
        let dabData = this.model.getDabData();
        if (dabData.hasCellToDab()) {
            this.handleDabActive();
        }
    }
}
//# sourceMappingURL=TicketController.js.map